import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'

import PhoneSmallIcon from 'public/icons/phone-small.svg'
import MailIcon from 'public/icons/mail.svg'
import Button from 'components/Button'
import WhatsappIcon from 'public/icons/whatsapp.svg'
import style from './ContactsItem.style'

const ContactsItemStyled = styled.div(props => ({ ...style(props) }))

const ContactsItem = ({ t, image, name, position, speaking, phone, email, columns }) => {
    return (
        <ContactsItemStyled columns={columns === 2 && columns}>
            <div className="contactsItem-image">
                <img alt={name} src={image} className="contactsItem-imageImage" />
            </div>
            {(name || position || speaking || phone || email) && (
                <div className="contactsItem-content">
                    {/* eslint-disable react/no-danger */}
                    {name && name.length > 0 && (
                        <div className="contactsItem-contactName" dangerouslySetInnerHTML={{ __html: name }} />
                    )}
                    {position && position.length > 0 && (
                        <div className="contactsItem-contactPosition" dangerouslySetInnerHTML={{ __html: position }} />
                    )}
                    {speaking && speaking.length > 0 && (
                        <div className="contactsItem-contactSpeaking">
                            {t('speaking')} <span dangerouslySetInnerHTML={{ __html: speaking }} />
                        </div>
                    )}
                    {phone && (
                        <div className="contactsItem-contactWrapper">
                            <span>
                                <PhoneSmallIcon />
                            </span>
                            <span className="contactsItem-contactPhone" dangerouslySetInnerHTML={{ __html: phone }} />
                        </div>
                    )}
                    {email && (
                        <div className="contactsItem-contactWrapper">
                            <span>
                                <MailIcon />
                            </span>
                            <span className="contactsItem-contactEmail" dangerouslySetInnerHTML={{ __html: email }} />
                        </div>
                    )}
                    {phone && (
                        <div className="contactsItem-contactButton">
                            <Button
                                className="animate"
                                link={`https://wa.me/${phone.replace(/[^\d]/g, '')}`}
                                variation="primary rounded"
                                white
                                hasIcon
                                smallest>
                                <WhatsappIcon /> {t('whatsapp-message')}
                            </Button>
                        </div>
                    )}
                </div>
            )}
        </ContactsItemStyled>
    )
}

ContactsItem.propTypes = {
    t: PropTypes.func.isRequired,
    image: PropTypes.string,
    name: PropTypes.string,
    position: PropTypes.string,
    speaking: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    columns: PropTypes.oneOf([2, 4])
}

ContactsItem.defaultProps = {
    image: '/images/fallback/contacts.svg',
    name: undefined,
    position: undefined,
    speaking: undefined,
    phone: undefined,
    email: undefined,
    columns: 4
}

export default withTranslation('common')(withTheme(ContactsItem))
